import { useAtom } from "@dbeining/react-atom";
import { Alert, Container } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { userAtom } from "../../atoms";
import { HubCardGrid } from "../../components/HubCards/HubCardGrid";
import { settingsAdminHubCards } from "../../navigation/appNavigation";
import {
    filterNavItemsByRoles,
    getUserRoleNames,
    SETTINGS_NON_ADMIN_MESSAGE,
} from "../../navigation/navVisibility";

const SettingsPage = () => {
    const currentUser = useAtom(userAtom);
    const userRoleNames = getUserRoleNames(currentUser?.identity.roles ?? []);
    const visibleAdminCards = filterNavItemsByRoles(settingsAdminHubCards, userRoleNames);

    return (
        <Container fluid>
            <Helmet>
                <title>Settings</title>
            </Helmet>

            <h1>Settings</h1>

            {visibleAdminCards.length > 0 ? (
                <>
                    <h3 className="mt-4">Administration</h3>
                    <HubCardGrid cards={visibleAdminCards} />
                </>
            ) : (
                <Alert variant="info" className="mt-3">
                    {SETTINGS_NON_ADMIN_MESSAGE}
                </Alert>
            )}
        </Container>
    );
};

export { SettingsPage };
